import Select from "react-select";
import React from "react";


export const WorkAuthorization = (
    {
        handleChangeWorkAuthorization,
        selectedWorkAuthorization,
        workAuthorizations
    }
)=>{

    return (
        <div className="resumeupdatealjob Ajlefthead work-authorizaljob">
            <h2>Work Authorization</h2>
            <Select
                id="work_authorization"
                name="term-contract"
                options={workAuthorizations}
                value={selectedWorkAuthorization}
                onChange={handleChangeWorkAuthorization}
                placeholder="Work Authorization"
                isSearchable
                required
                isClearable={true}
                styles={{
                    control: (provided) => ({
                        ...provided,
                        padding: '4px 5px',
                        border: '1px solid rgba(46, 46, 46, 0.5)',
                        boxShadow: '0px 1px 4px rgba(115, 153, 191, 0.05)',
                        borderRadius: '8px'
                    }),
                }}
            />
        </div>
    )
}